import { useUserSelectMulti } from "@/User/Components/SelectMulti/use-user-select-multi";
import classNameMerge from "classnames";
import { isNil } from "lodash";
import React from "react";
import ReactSelect from "react-select";
import { twMerge } from "tailwind-merge";
import { buildInput, DropdownIndicator, Option } from "./Components";

const SelectMulti = ({
    id,
    name,
    isClearable = true,
    isSearchable = false,
    value,
    options,
    className,
    handleChange,
    placeholder = '',
    classNames = '',
    inputClasses = '',
    disabled = false,
    sort = false,
}) => {
    const { selectedValue, optionArr } = useUserSelectMulti({ options, value, sort });

    const InputComponent = buildInput(inputClasses);

    const RM = ReactSelect?.default ? ReactSelect.default : ReactSelect;

    return (
        <>
            <label htmlFor={id ? id : value}>
                <RM
                    inputId={id}
                    menuPlacement="auto"
                    id={id ? id : name}
                    name={name}
                    isDisabled={disabled}
                    className={`react-select bg-white rounded-lg ${className}`}
                    closeMenuOnSelect={false}
                    components={{ DropdownIndicator, IndicatorSeparator: () => null, InputComponent, Option }}
                    value={selectedValue}
                    onChange={(e) => handleChange(e)}
                    options={optionArr}
                    isClearable={isClearable}
                    isSearchable={isSearchable}
                    hideSelectedOptions={false}
                    isMulti={true}
                    styles={{
                        option: (baseStyles, { data }) => {
                            return isNil(data.value) || data.value === ''
                                ? { ...baseStyles, height: "2rem" }
                                : { ...baseStyles };
                        },
                    }}
                    placeholder={placeholder}
                    classNames={{
                        ...classNames,
                        control: () => `!border-steel-grey !px-4 !py-2 !rounded-lg !bg-white !shadow-none`,
                        option: (state) => classNameMerge(
                            `!text-sm !leading-none !text-midnight !p-4 font-normal`,
                            {
                                '!bg-silk-blue/[.08]': state.isSelected,
                                '!bg-inherit': state.isFocused
                            },
                            classNames?.control ? classNames?.control() : '',
                        ),
                        valueContainer: () => `!flex-nowrap !overflow-x-auto ${classNames?.valueContainer ? classNames.valueContainer() : ''}`,
                        multiValue: () => "!bg-transparent after:content-['、'] !p-0 !m-0 !shrink-0 last-of-type:after:hidden",
                        multiValueLabel: () => "!text-sm !p-0",
                        multiValueRemove: () => '!hidden',
                        placeholder: () => twMerge(`text-sm leading-none !text-trout whitespace-nowrap !m-0 ${inputClasses}`),
                        dropdownIndicator: () => `!p-0`,
                        input: () => `text-sm leading-none h-3.5 !m-0 !p-0`,
                        clearIndicator: () => `h-3.5 w-3.5 flex items-center justify-center`,
                        menu: () => '!shadow-select-menu !rounded-lg !my-0.5',
                    }}

                />
            </label>
        </>
    );
};

export default SelectMulti;
